import { useV2ListProjectCreditsQuery } from "@generated";
import { ProjectCredit } from "../types/ProjectCredit";

interface UseListProjectCreditsArgs {
  projectId: string;
  paymentCreditsMap: Record<string, { paymentSource: string; description: string; criteria: string }>;
  page?: { number?: number; size?: number };
}

const useListProjectCredits = ({
  projectId,
  paymentCreditsMap,
  page,
}: UseListProjectCreditsArgs) => {

  const { data, error, isLoading, isFetching, refetch } =
    useV2ListProjectCreditsQuery({
      filter: { project: projectId, active: true },
      include: ["payment-credit"],
      page: page || { size: 250 },
    });

  const projectCredits: ProjectCredit[] =
    data?.data?.map((c: any) => {
      const pcData = c.relationships?.["payment-credit"]?.data;
      const pcId = pcData ? String(pcData.id) : null;
      const pc = pcId ? paymentCreditsMap[pcId] : null;
      return {
        id: String(c.id),
        amount: parseFloat(c.attributes?.amount) || 0,
        criteria: c.attributes?.criteria || "",
        paymentCreditId: pcId,
        paymentSource: pc?.paymentSource || "",
        description: pc?.description || "",
      };
    }) || [];

  const pageMeta = {
    pageCount: data?.meta?.["page-count"] || 1,
    recordCount: data?.meta?.["record-count"] || 0,
  };

  return {
    projectCredits,
    projectCreditsError: error,
    projectCreditsLoading: isLoading,
    projectCreditsFetching: isFetching,
    pageMeta,
    refetch,
  };
};

export default useListProjectCredits;
